import { html } from 'lit-element';

export const defaultStyle = html`
    <style>
        :host {
            display: block;
        }
    </style>
`;

export const gridStyle = html`
    <style>
        :host {
            width: 50%;
        }

        @media (min-width: 900px) {
            :host {
                width: 33.3%;
            }
        }

        #native-ad-id {
            flex: 0 1 auto;
            height: 100%;
        }
        #native-ad-id > div {
            height: 100%;
        }
    </style>
`;

export const listStyle = html`
    <style>
        :host {
            width: 100%;
            padding: 0;
        }
    </style>
`;

export const objectPageStyle = html`
    <style>
        :host {
            width: 100%;
            padding: 0;
        }
    </style>
`;

export const holidayRentalStyle = html`
    <style>
        :host {
            width: 100%;
            padding: 0 0 16px;
        }
    </style>
`;
